import type { ShopTrackingPreferencesPatchDto } from "../generated/schema";
import useInvalidateShopSuspense from "./use-invalidate-shop-suspense";
import useInvalidateShopTrackingPreferencesSuspense from "./use-invalidate-shop-tracking-preferences-suspense";
import { useApiMutation } from "./use-api-mutation";

interface UseUpdateShopTrackingPreferencesOptions {
	showSuccessNotification?: boolean;
	/** Defaults to showSuccessNotification, as both used to share one flag. */
	showErrorNotification?: boolean;
}

export default function useUpdateShopTrackingPreferences(
	options: UseUpdateShopTrackingPreferencesOptions = {},
) {
	const {
		showSuccessNotification = true,
		showErrorNotification = showSuccessNotification,
	} = options;
	const invalidateShop = useInvalidateShopSuspense();
	const invalidateShopTrackingPreferencesSuspense =
		useInvalidateShopTrackingPreferencesSuspense();

	return useApiMutation("patch", "/shops/{shopId}/tracking/preferences", {
		notify: { success: showSuccessNotification, error: showErrorNotification },
		onSuccess: (_data, variables) => {
			const vars = variables as { shopId: string; requestBody: ShopTrackingPreferencesPatchDto };
			invalidateShop(vars.shopId);
			invalidateShopTrackingPreferencesSuspense(vars.shopId);
		},
		mapVariables: ({
			shopId,
			requestBody,
		}: {
			shopId: string;
			requestBody: ShopTrackingPreferencesPatchDto;
		}) => ({
			params: { path: { shopId } },
			body: requestBody,
		}),
	});
}
